import classNames from 'classnames';
import type { CSSProperties } from 'react';
import type { EssenceType } from '@sorrem/shared';
import { getEssenceColor } from '@sorrem-client/game/essence-integration';
import styles from './EssenceOrb.module.scss';

interface EssenceOrbProps {
    /** The essence type, which sets the orb's color. */
    type: EssenceType;
    /** Sizes the orb by setting `--essence-orb-size` (16px when unset). */
    className?: string;
}

/**
 * The essence orb the loadout's vessel shows, tinted the essence color:
 * every amount of essence in the UI is drawn with it, never a colored dot.
 * Decorative; the amount or type name beside it carries the meaning.
 */
export function EssenceOrb({ type, className }: EssenceOrbProps): JSX.Element {
    return <span className={classNames(styles.essenceOrb, className)} style={{ '--orb-color': getEssenceColor(type) } as CSSProperties} aria-hidden='true' />;
}
